import datos from "src/services/datos";


export const getDataDashboard = async (vistaConsulta, proyecto) => {

    const dataDashboard = new datos('cuentas')
    const response = await dataDashboard.dboxDashboard(vistaConsulta, proyecto)

    return response.wsResponse;
};